import React, { memo } from 'react';

import BaseInput from '../helpers/Input';
import BaseTextarea from '../helpers/Textarea';
import PrettyError from '../decorators/PrettyError';
import DisplayError from '../decorators/DisplayError';
import Popup from '../helpers/Popup';
import Button from '../helpers/Button';
import { IconButton } from '../helpers/IconButton';
import FormGroup from '../helpers/FormGroup';
import { InputProps } from '../helpers/AutoComplete';

const Input = PrettyError(DisplayError(BaseInput));
const Textarea = PrettyError(DisplayError(BaseTextarea));

const OneOffApproachPopup = props => {
  const {
    oneOff,
    countTargets,
    loadingCountTargets,
    isValid,
    loading,
    suggestModule,
    suggestAnalyst,
    suggestBuyer,
    suggestProject,
    onChange,
    onSave,
    onClose,
    onCountTargets,
  } = props;
  const disabledButton = !isValid || loading;

  const footer = (
    <Button className="btn-primary" disabled={disabledButton} onClick={onSave}>
      Create
    </Button>
  );

  return (
    <Popup footer={footer} header="Create One-off Approach" id="oneOffApproach" onClose={onClose}>
      <div className="row">
        <FormGroup className="col-md-6">
          <Input
            className="input-sm"
            label="Harvey Tag"
            name="tag"
            onBlur={onCountTargets}
            onChange={onChange}
            root={oneOff}
            autoFocus
            canDisplayError
            deep
            required
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-md-6">
          <label className="field-label">Targets</label>
          <div className="d-flex align-items-center">
            <IconButton
              className="mr8"
              disabled={loadingCountTargets}
              icon="refresh"
              onClick={onCountTargets}
              size="sm"
              title="Count targets"
            />
            {countTargets}
          </div>
        </FormGroup>
        <FormGroup className="col-md-6">
          <InputProps className="form-control input-sm" name="suggestBuyer">
            {suggestBuyer}
          </InputProps>
        </FormGroup>
        <FormGroup className="col-md-6">
          <InputProps className="form-control input-sm" name="suggestModule">
            {suggestModule}
          </InputProps>
        </FormGroup>
        <FormGroup className="col-md-6">
          <InputProps className="form-control input-sm" name="suggestProject">
            {suggestProject}
          </InputProps>
        </FormGroup>
        <FormGroup className="col-md-6">
          <InputProps className="form-control input-sm" name="suggestAnalyst">
            {suggestAnalyst}
          </InputProps>
        </FormGroup>
        <FormGroup className="col-md-12">
          <Textarea
            label="Description"
            name="description"
            onChange={onChange}
            placeholder=""
            root={oneOff}
            rows="4"
            deep
            showLabel
          />
        </FormGroup>
      </div>
    </Popup>
  );
};

export default memo(OneOffApproachPopup);
